<cmps-dialog>
    <cmps-dialog-body>
        <div class="cmps-cdk-d-flex cmps-cdk-align-items-center">
            <div class="cmps-cdk-font-bold">
                {{ _i18n._11216_CALL_IN_PROGRESS | translate }}
            </div>
            <div
                class="cmps-cdk-border-l-width-2px cmps-cdk-border-l-solid cmps-cdk-ml-1 cmps-cdk-mr-0dot25"
            >
                &nbsp;
            </div>
            <div>
                <button
                    class="cmps-icon-button--no-bg cmps-cdk-mr-0dot5"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n._11228_REJOIN_CALL | translate"
                    placement="bottom-center"
                    (click)="
                        _service.inviteToCurrentCall(
                            _service.callHandle.organizerId
                        )
                    "
                >
                    <cmps-icon svgIcon="phone-in-talk"></cmps-icon>
                </button>
                <button
                    class="cmps-icon-button--no-bg"
                    cmpsIconButton
                    [cmpsTooltipTrigger]="_i18n._11229_END_CALL | translate"
                    placement="bottom-center"
                    (click)="_service.endCurrentCall()"
                >
                    <cmps-icon
                        class="cmps-cdk-bg-color-red-100 cmps-cdk-fill-white"
                        svgIcon="phone-hangup"
                    ></cmps-icon>
                </button>
            </div>
            <div
                class="cmps-cdk-border-l-width-2px cmps-cdk-border-l-solid cmps-cdk-ml-1 cmps-cdk-mr-0dot25"
                *ngIf="_service.buttons?.length > 0"
            >
                &nbsp;
            </div>
            <ng-container *ngFor="let b of _service.buttons">
                <ng-container *ngTemplateOutlet="b"></ng-container>
            </ng-container>
        </div>
    </cmps-dialog-body>
</cmps-dialog>
